// src/services/taskService.js
import api from './api';

const taskService = {
  // Get all tasks (con filtros opcionales: project_id, status, assigned_to, etc.)
  getTasks: async (params = {}) => {
    const response = await api.get('/tasks', { params });
    return response.data;
  },

  // Get single task
  getTaskById: async (id) => {
    const response = await api.get(`/tasks/${id}`);
    return response.data;
  },

  // Get the immutable audit timeline for a task.
  getHistory: async (id) => {
    const response = await api.get(`/tasks/${id}/history`);
    return response.data;
  },

  // Create task
  createTask: async (taskData) => {
    const response = await api.post('/tasks', taskData);
    return response.data;
  },

  // Update task
  updateTask: async (id, taskData) => {
    const response = await api.put(`/tasks/${id}`, { ...taskData, expected_revision: taskData.expected_revision || taskData._edit_revision });
    return response.data;
  },

  // Update status, expected date and progress comment as one atomic action.
  recordProgress: async (id, progressData) => {
    const response = await api.post(`/tasks/${id}/progress`, progressData);
    return response.data;
  },

  // Delete task
  deleteTask: async (id) => {
    const response = await api.delete(`/tasks/${id}`);
    return response.data;
  },
};

export default taskService;
